import * as React from 'react';

interface IFilter {
  // Systems must still be loaded for the first time to set the initially
  // active systems.
  mustLoadSystems: boolean;
  setMustLoadSystems: (value: boolean) => void;
  activeSystems: number[];
  setActiveSystems: (ids: number[]) => void;
}

const FilterContext = React.createContext<IFilter>({
  mustLoadSystems: true,
  setMustLoadSystems: () => {},
  activeSystems: [],
  setActiveSystems: () => {},
});

export { FilterContext, IFilter }
